import { render, staticRenderFns } from "./TvaScroller.vue?vue&type=template&id=2c19c779&scoped=true&"
import script from "./TvaScroller.vue?vue&type=script&lang=js&"
export * from "./TvaScroller.vue?vue&type=script&lang=js&"
import style0 from "./TvaScroller.vue?vue&type=style&index=0&id=2c19c779&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c19c779",
  null
  
)

export default component.exports